<section class="error-404__flex">
    <div class="error-404__logo">
        <img proLogoImg alt="logo" class="content-logo__logo">
    </div>
    <div class="error-404__container">
        <div class="error-404__row">
            <div class="error-404__column">
                <div class="error-404__imageContainer">
                    <img class="error-404__image"
                        src="https://d2i8kkeqh9ciqw.cloudfront.net/74a126c/assets/img/404/404.gif" />
                </div>
                <div class="error-404__content">
                    <h1 class="error-404__title">{{ titleText | translate:_transParam }}</h1>
                    <h1 class="error-404__subtitle">{{ subtitleText | translate:_transParam }}</h1>
                    <span class="error-404__message">{{ messageText | translate:_transParam }}</span>
                </div>
                <signaturit-button *ngIf="urlCallback" text="{{ callbackText | translate:_transParam }}" type="primary" size="sm" (click)="redirectCallback(urlCallback)">
                </signaturit-button>
                <div>
                    <span class="error-404__error">{{ notifMessage }}</span>
                </div>
            </div>
        </div>
    </div>
</section>
